import { create } from "zustand";

export const usePageStore = create((set) => ({
  isDetailPage: false,

  setIsDetailPage: (value) => set({ isDetailPage: value }),
}));
